import { Box } from '@mui/material';
import React, { FC } from 'react';
import { BhiDialog } from 'src/UIKit';
import { FormView } from 'src/components/FormPart/FormView';
import { DynamicGroupRulesFormDialogController } from '../../controllers';
import { GroupFormData } from '../../types';
import { DynamicGroupRulesForm, DynamicGroupRulesFormProps } from './DynamicGroupRulesForm';

interface DynamicGroupRulesFormDialogProps extends DynamicGroupRulesFormDialogController {
  onSuccess?: () => void;
}

export const DynamicGroupRulesFormDialog: FC<DynamicGroupRulesFormDialogProps> = props => {
  const {
    isOpen,
    close,
    initFormData,
    customFields,
    customGroups,
    isContactsCountInfoLoading,
    contactsCountInfo,
    testRules,
    submit,
    onSuccess,
  } = props;

  const dialogTitle = initFormData?.name ? `Edit Rules for ${initFormData.name}` : 'Edit Rules';

  return (
    <BhiDialog isOpen={isOpen} onClose={close} title={dialogTitle} paperSx={{ minWidth: '820px' }}>
      {initFormData && (
        <Box px={2.5} pb={2.5}>
          <FormView<GroupFormData, DynamicGroupRulesFormProps>
            formData={initFormData}
            component={DynamicGroupRulesForm}
            componentProps={{
              customFields: customFields || [],
              customGroups,
              closeForm: close,
              isContactsCountInfoLoading,
              contactsCountInfo,
              testRules,
            }}
            onSubmit={(full, dirty) =>
              submit(full, dirty, onSuccess ? async () => onSuccess() : undefined)
            }
          />
        </Box>
      )}
    </BhiDialog>
  );
};
